export const showSearchForm = () => {
    
};

export const showNavBar = () => {
    $('#nav-open-close').click(function() {

      if( $('#nav-open-close').hasClass('open') ){
       	/*$('#menu-desplegable').fadeOut(200, function(){
           $(this).addClass('hidden'); //or any other class
        });*/
        $('#menu-desplegable').removeClass('open');
        $('#header').removeClass('menu-opened');
        $('#nav-open-close').removeClass('open');
      } else {
        $('#nav-open-close').addClass('open');
        $('#header').addClass('menu-opened');
        $('#menu-desplegable').addClass('open');
        /*$('#menu-desplegable').removeClass('hidden').fadeOut(0).fadeIn(200)*/
      }
    });

};

